import { create } from 'zustand';

/**
 * Phase 16.4 — Sync-Status (in-memory; nicht persistiert).
 *
 *   idle     — initialer Zustand, noch nicht gesynct in dieser Session
 *   syncing  — POST /api/savegame/save läuft gerade
 *   synced   — letzter Sync war erfolgreich
 *   error    — Server hat 4xx/5xx geliefert
 *   offline  — Network-Fehler (fetch threw)
 */
export type SyncStatus = 'idle' | 'syncing' | 'synced' | 'error' | 'offline';

export interface CloudSyncState {
  status: SyncStatus;
  lastSyncedAt: number | null;
  lastError: string | null;
  setStatus: (status: SyncStatus, error?: string | null) => void;
  setSyncedAt: (ts: number) => void;
}

export const useCloudSyncStore = create<CloudSyncState>((set) => ({
  status: 'idle',
  lastSyncedAt: null,
  lastError: null,
  setStatus: (status, error = null) => set({ status, lastError: error }),
  setSyncedAt: (ts) => set({ lastSyncedAt: ts, status: 'synced', lastError: null }),
}));
